import getImgSrcWorkaround from '@/utils/images';
import { VideoContainer, VideoOverlay } from './style';

const VideoPreview = ({ prefersReducedMotion, videoUrl }) => {
  return (
    <>
      <VideoOverlay />
      <VideoContainer autoPlay={!prefersReducedMotion} playsInline loop muted>
        <source src={getImgSrcWorkaround(videoUrl)} />
      </VideoContainer>
    </>
  );
};

export default VideoPreview;
